import {
  landlordConverter,
  landlordStatusConverter,
  propertyManagementEmailsExportConverter,
} from 'data/convertors/Landlord.converters';
import {
  TChangeLandlordStatusUI,
  TLandlordGetDB,
  TLandlordGetUI,
  TPMEmailsExportUI,
} from 'data/types/Landlord.types';
import { downloadFile } from 'api/sevices/fileServices';
import {
  TPageableDataWithContentUi,
  TTableFilters,
} from 'data/types/Table.types';
import { ELandlordsUrl } from 'data/urls/landlords.url';
import { authSplitApi } from 'redux/helpers/slice.helpers';
import { filtersConverter } from 'data/convertors/General.converters';

export const landlordApi = authSplitApi('landlords', ['landlordsTable']).injectEndpoints({
  endpoints: build => ({
    getLandlords: build.query<
      TPageableDataWithContentUi<TLandlordGetUI[]>,
      TTableFilters<{ [key: string]: string | string[] }, string | undefined>
    >({
      query({ page, pageSize, filters, sortDirection, sortField }) {
        const validFilters = filtersConverter.toDb(filters);
        return {
          url: `${ELandlordsUrl.PROPERTY_MANAGEMENT}`,
          method: 'GET',
          params: {
            page,
            size: pageSize,
            ...validFilters,
            ...(sortField && sortDirection && { sortField, sortDirection }),
          },
        };
      },
      transformResponse: (data: TPageableDataWithContentUi<TLandlordGetDB[]>) => {
        return {
          ...data,
          content: data.content.map(item => landlordConverter.fromDb(item)),
        };
      },
      providesTags: ['landlordsTable'],
    }),
    changeLandlordStatus: build.mutation<void, TChangeLandlordStatusUI>({
      query(body) {
        return {
          url: `${ELandlordsUrl.PROPERTY_MANAGEMENT}/${ELandlordsUrl.STATUS}`,
          method: 'PATCH',
          body: {
            propertyManagementId: body.propertyManagementId,
            status: landlordStatusConverter.toDb(body.propertyManagementStatus),
          },
        };
      },
      invalidatesTags: ['landlordsTable'],
    }),
    getEmails: build.query<null, TPMEmailsExportUI>({
      query(params) {
        return {
          url: `${ELandlordsUrl.PROPERTY_MANAGEMENT}/${ELandlordsUrl.EXPORT}/${ELandlordsUrl.PM_EMAILS}`,
          method: 'GET',
          params: propertyManagementEmailsExportConverter.toDb(params),
          responseHandler: async response => {
            const file = await response.blob();
            downloadFile(file, 'pmEmails.csv');
            return null;
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetLandlordsQuery,
  useChangeLandlordStatusMutation,
  useLazyGetEmailsQuery,
} = landlordApi;
